import React from "react";
// import Notifications from "react-notify-toast";
import { ApolloProvider } from "react-apollo";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import App from "./App";
import { client } from "./constants/baseUrl";
import "./constants/i18n";
import {registerLocale} from "react-datepicker";
import de from 'date-fns/locale/de';
import store from "./store/index";
registerLocale('de', de);

ReactDOM.render(
  
  <ApolloProvider client={client}>
    <ToastContainer
      position="bottom-right"
      autoClose={1500}
      hideProgressBar={true}
      newestOnTop={false}
      closeButton={false}
      closeOnClick
      rtl={false}
      pauseOnVisibilityChange
      draggable
      pauseOnHover
    />
    <Provider store={store}>
        <App />
    </Provider>
  </ApolloProvider>,
  document.getElementById("root")
);
